import Form from "react-bootstrap/Form";

export default function CheckboxWithLabel({
  inputId,
  label = null,
  type = "check",
  // Pass over the react-hook-form register function!
  register = null,
  // Wraper styling, default to margin bottom 3 (mb-3)
  wrapperClass = "mb-3",
  inputProps = null,
}) {
  if (!inputId) {
    console.error(`ERR: Missing input ID! InputWithLabel`);
    return <></>;
  }

  return (
    <div className={wrapperClass}>
      <Form.Check // prettier-ignore
        type={type}
        className="form-control"
        label={label}
        {...register(inputId)}
        {...inputProps}
      />
    </div>
  );
}
